
import api from './api';

class SummaryRanking {

	constructor (Api) {
		this.Api = Api;
	}

	get (query) {
		return this.Api.get({
			url:  'v1.1/m/summaryRanking/',
			query
		});
	}

}

SummaryRanking.$inject = ['Api'];

export default angular.module('service.summaryRanking', [api])
	.service('SummaryRanking', SummaryRanking)
	.name;



// WEBPACK FOOTER //
// ./src/service/summaryRanking.js